import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
});

async function loginService(username, password) {
  const response = await API.post("/login", { username, password });
  return response.data;
}

export { loginService };
